$(function main() {
  $("a.toggle").next(".details").hide();

  $("a.toggle").click(function toggleLink() {
    var $toggle = $(this);
    var rm = "(+ Read More)";
    var rl = "(- Read Less)";

    $("a.toggle").not($toggle).text(rm).next(".details").slideUp();
    $toggle.next(".details").slideToggle();
    if ($toggle.text().toLowerCase().indexOf("more") >= 0) {
      $toggle.text(rl);
    } else {
      $toggle.text(rm);
    }
  });

  $(".tabs").on("click", ".tab-headers a", function(event) {
    event.preventDefault();

    var $tabHeader = $(this).parent("li");
    var $tabContainer = $tabHeader.closest(".tabs");
    var activeIndex = $tabContainer.find(".tab-headers li").index($tabHeader);
    $tabContainer.find(".active").removeClass("active");
    $tabHeader.addClass("active");
    $tabContainer.find(".tab-content").eq(activeIndex).addClass("active");
  });

  $("details").each(function() {
    var $details = $(this);
    $details.not("[open]").find(".details").slideUp();
  })

  $("details").on("click", "summary", function(event) {
    // event.preventDefault();
    var $summary = $(this);
    var $details = $summary.parent("details");
    var isOpen = !!$details.attr("open")
    var animation = isOpen? "slideUp" : "slideDown";

    // If was open, slide first then set attr
    if (isOpen) {
      event.preventDefault();
      $summary.siblings(".details").slideUp(function() {
        $details.removeProp("open", "open");
      });
    } else {
      setTimeout(function() {
        $summary.siblings(".details").slideDown();
      });
    }
  });

  if (navigator.share) {
    $("a.navshare").css("display", "inline-block").click(function(){
      navigator.share({
        title: document.title,
        text: "Check out MPC:Driven",
        url: document.location
      })
      .then(function() {
        console.log('Successful share')
      })
      .catch( function(error) {
        console.log('Error sharing', error);
      })
    });
  } else {
    $("div.beshare").css("display","block").BEShare({
      "type": "inline",
      "message": "Driving Opportunities at MPC",
      "removeHash": true,
      "prefix": "noicon icon-",
      "via": "MarathonPetroCo",
      "targets": [
        "Facebook",
        "Twitter",
        "LinkedIn",
        "Email",
        "SMS"
      ]
    });
  }

  if (window["tinymce"]) {
  	tinymce.on("AddEditor", function (e) {
      console.log(e.editor.id)
    	var $editor = $("#" + e.editor.id);
    	$editor.closest(".owl-stage-outer").css("z-index", 8998);
    });
    tinymce.on("RemoveEditor", function (e) {
      var $editor = $("#" + e.editor.id);
    	$editor.closest(".owl-stage-outer").css("z-index", "");
    });
  }
});
